export default __webpack_public_path__ + "static/media/shea_profile.c9854ab9.jpg";